@if (loading) {
  <div class="flex justify-center items-center mt-8">
    <mat-spinner></mat-spinner>
  </div>
}

@if (!loading && error) {
  <mat-card class="m-4">
    <mat-card-content>
      <h2 i18n="@@AcceptInviteError">Error</h2>
      <p>{{ error }}</p>
    </mat-card-content>
  </mat-card>
}

@if (!loading && !error && blocked) {
  <mat-card class="m-4">
    <mat-card-content>
      <h2 i18n="@@AcceptInviteCannotJoinHeading">Cannot join</h2>
      @if (groupName) {
        <p i18n="@@AcceptInviteGroupLabel">Group: {{ groupName }}</p>
      }
      <p>{{ infoMessage }}</p>
      <button mat-raised-button color="primary" (click)="navigateToGroup()" i18n="@@AcceptInviteGoToGroup">Go to Group</button>
    </mat-card-content>
  </mat-card>
}

@if (!loading && !error && !blocked && !joined) {
  <mat-card class="m-4">
    <mat-card-content>
      <h2 i18n="@@AcceptInviteTitle">You've been invited!</h2>
      <p i18n="@@AcceptInviteGroupLabel">Group: {{ groupName }}</p>
      <p>
        <ng-container i18n="@@AcceptInviteRoleLabelPrefix">Role:</ng-container>&nbsp;
        @if (inviteType === 'contributor') {
          <span i18n="@@UserGroupInspectMembers_Contributor">Contributor</span>
        } @else {
          <span i18n="@@UserGroupInspectMembers_Watcher">Watcher</span>
        }
      </p>
      <button mat-raised-button color="primary" (click)="joinTeamButtonClicked()" i18n="@@AcceptInviteJoinTeamButton">Join Group</button>
    </mat-card-content>
  </mat-card>
}

@if (!loading && !error && !blocked && joined) {
  <mat-card class="m-4">
    <mat-card-content>
      @if (infoMessage) {
        <h2 i18n="@@AcceptInviteAlreadyMemberHeading">Already a member</h2>
        <p>{{ infoMessage }}</p>
      } @else {
        <h2 i18n="@@AcceptInviteSuccess">Successfully joined!</h2>
        <p i18n="@@AcceptInviteSuccessMessage">You are now a member of {{ groupName }}.</p>
      }
      <button mat-raised-button color="primary" (click)="navigateToGroup()" i18n="@@AcceptInviteGoToGroup">Go to Group</button>
    </mat-card-content>
  </mat-card>
}
